import React from "react";
import { arrayOf, string } from "prop-types";

import "./shoulder-tags.m.css";

const ShoulderTags = ({ tags = ["Forum", "Thematic"], ...props }) => {
  return (
    <div styleName="shoulder-tags" {...props}>
      {tags.map((tag, index) => (
        <div key={index} styleName="shoulder-tag">
          {tag}
        </div>
      ))}
    </div>
  );
};

ShoulderTags.propTypes = {
  tags: arrayOf(string)
};

export default ShoulderTags;